<template>
  <v-container class="main-container responsive-height mt5-wrapper">
    <v-row dense>
      <v-col cols="12" class="position-relative">
        <div class="mt5-create-account">
          <CreateAccountDropdown></CreateAccountDropdown>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CreateAccountDropdown from "@/components/GlobalComponents/CreateAccountDropdown";

export default {
  components: {
    CreateAccountDropdown,
  },
};
</script>
